export default theme => ({
  content: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  footer: {
    width: '100%',
    height: '32px',
    marginTop: '8px',
    display: 'flex',
    justifyContent: 'center',
    borderTop: `1px solid ${theme.colors.grey[100]}`
  },
  loader: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  excelIcon: {
    '& svg': {
      ' & path:first-of-type': {
        fill: theme.colors.actionMajor[500]
      },
      '& path:nth-of-type(3)': {
        fill: theme.colors.actionMajor[500]
      }
    }
  }
});